import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';

const CatalogContext = createContext();

export const CatalogProvider = ({ children }) => {
  const { lang } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/shopify/products?lang=${lang}`)
      .then((res) => {
        if (!res.ok) throw new Error('Impossible de charger les produits');
        return res.json();
      })
      .then((data) => {
        if (mounted) {
          setProducts(data.products || []);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (mounted) {
          setError(err.message);
          setLoading(false);
        }
      });
    return () => { mounted = false; };
  }, [lang]);

  return (
    <CatalogContext.Provider value={{ products, loading, error }}>
      {children}
    </CatalogContext.Provider>
  );
};

export const useCatalog = () => useContext(CatalogContext);
